import { FC, SVGProps } from 'react';

export const Gamezone: FC<SVGProps<{ fill?: string }>> = ({
  fill = 'white',
}) => {
  return (
    <svg
      fill='none'
      height='32'
      viewBox='0 0 33 32'
      width='33'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M29.8333 14.5346V5.46797C29.8333 3.46797 28.98 2.66797 26.86 2.66797H21.4733C19.3533 2.66797 18.5 3.46797 18.5 5.46797V14.5346C18.5 16.5346 19.3533 17.3346 21.4733 17.3346H26.86C28.98 17.3346 29.8333 16.5346 29.8333 14.5346Z'
        stroke={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
      <path
        d='M29.8333 26.532V24.132C29.8333 22.132 28.98 21.332 26.86 21.332H21.4733C19.3533 21.332 18.5 22.132 18.5 24.132V26.532C18.5 28.532 19.3533 29.332 21.4733 29.332H26.86C28.98 29.332 29.8333 28.532 29.8333 26.532Z'
        stroke={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
      <path
        d='M14.4993 17.468V26.5346C14.4993 28.5346 13.646 29.3346 11.526 29.3346H6.13935C4.01935 29.3346 3.16602 28.5346 3.16602 26.5346V17.468C3.16602 15.468 4.01935 14.668 6.13935 14.668H11.526C13.646 14.668 14.4993 15.468 14.4993 17.468Z'
        stroke={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
      <path
        d='M14.4993 5.46797V7.86797C14.4993 9.86797 13.646 10.668 11.526 10.668H6.13935C4.01935 10.668 3.16602 9.86797 3.16602 7.86797V5.46797C3.16602 3.46797 4.01935 2.66797 6.13935 2.66797H11.526C13.646 2.66797 14.4993 3.46797 14.4993 5.46797Z'
        stroke={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
    </svg>
  );
};
